import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconClose16 } from '@cian/ui-kit';
import * as React from 'react';
import { IconButton } from '../../../IconButton';
import { Counter } from '../Counter';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(_ref) {
  var contentOptions = _ref.contentOptions,
    counter = _ref.counter,
    onCloseButtonClick = _ref.onCloseButtonClick;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['header'],
    children: [counter && /*#__PURE__*/_jsx("div", {
      className: styles['counter'],
      children: /*#__PURE__*/_jsx(Counter, _objectSpread({}, counter))
    }), (contentOptions === null || contentOptions === void 0 ? void 0 : contentOptions.headerContent) && /*#__PURE__*/_jsx("div", {
      className: styles['content'],
      children: contentOptions.headerContent
    }), /*#__PURE__*/_jsx(IconButton, {
      onClick: onCloseButtonClick,
      className: styles['close_button'],
      children: /*#__PURE__*/_jsx(IconClose16, {
        color: "icon-inverted-default"
      })
    })]
  });
};
Header.displayName = 'Header';